/*eslint-disable*/
import React, { useEffect, useContext } from "react";
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { language } from "config";
import { FirebaseContext } from "common";
function AuthLoading(props) {
  const { api } = useContext(FirebaseContext);
  const {
    fetchUser,
    fetchCommercialTypes,
    fetchIndustrialTypes,
    fetchUserTypes,
    fetchSettings,
    fetchBookings,
    fetchCancelReasons,
    fetchPromos,
    fetchBrokerEarnings,
    fetchUsers,
    fetchAdmins,
    fetchNotifications,
    fetchEarningsReport,
    signOut,
    fetchWithdraws,
    fetchChatMessages,
    fetchBrokerNotes,
    fetchAllListings,
    // fetchPublication,
    // publishToWeb,
    fetchAllBranches,
    fetchAgent,
    fetchAllUnAssignedAreas,
    fetchAllRegions,
    PPTokenGenerator,
    fetchPPLeads,
  } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const tokenManagementReducer = useSelector((state) => state.tokendata);


  useEffect(() => {

    console.log('tokenManagementReducer', tokenManagementReducer)

  }, [tokenManagementReducer])


  useEffect(() => {
    dispatch(fetchUser());
    dispatch(fetchAdmins());
    dispatch(fetchUserTypes());
    dispatch(fetchSettings());
    dispatch(fetchCommercialTypes());
    dispatch(fetchIndustrialTypes());
    // dispatch(fetchAgent("77412"));
    // dispatch(publishToWeb())
  }, [
    dispatch,
    fetchUser,
    fetchUserTypes,
    fetchCommercialTypes,
    fetchIndustrialTypes,
    fetchSettings,
    fetchChatMessages,
    fetchBrokerNotes,
    fetchAllBranches,
    fetchAgent,
    // fetchPublication,
  ]);
  useEffect(() => {
    if (auth.info) {
      if (auth.info.profile) {
        let role = auth.info.profile.userType;
        if (role === "landlord") {
          dispatch(api.fetchUsers());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchBookings(auth.info.uid, role));
          dispatch(api.fetchCancelReasons());
          dispatch(api.fetchPaymentMethods());
          dispatch(api.fetchPromos());
          dispatch(api.fetchCanvas());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchUserListinghistory());
          dispatch(api.fetchCommercialTypes());
          dispatch(api.fetchIndustrialTypes());
          dispatch(api.fetchBrokerTypes());
        } else if (role === "broker") {
          dispatch(api.fetchUsers());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchBookings(auth.info.uid, role));
          dispatch(api.fetchCancelReasons());
          dispatch(api.fetchPaymentMethods());
          dispatch(api.fetchAllRegions());
          dispatch(api.fetchPromos());
          dispatch(api.fetchCanvas());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchUserEnquiryhistory(null, auth.info.profile.brokerHomeOffice));
          dispatch(api.fetchUserListinghistory());
          dispatch(api.fetchBrokerNotes());
          dispatch(api.fetchUserTypes());
          dispatch(api.fetchSettings());
          dispatch(api.fetchCommercialTypes());
          dispatch(api.fetchIndustrialTypes());
        } else if (role === "tenant") {
          dispatch(api.fetchUsers());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchBookings(auth.info.uid, role));
          dispatch(api.fetchCancelReasons());
          dispatch(api.fetchCanvas());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchUserListinghistory());
          dispatch(api.fetchPaymentMethods());
          dispatch(api.fetchPromos());
          dispatch(api.fetchUserTypes());
          dispatch(api.fetchSettings());
          dispatch(api.fetchCommercialTypes());
          dispatch(api.fetchIndustrialTypes());
        } else if (role === "nophonetenant") {
          dispatch(api.fetchUsers());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchBookings(auth.info.uid, role));
          dispatch(api.fetchCancelReasons());
          dispatch(api.fetchPaymentMethods());
          dispatch(api.fetchPromos());
        } else if (role === "admin") {
          console.log("here bro");
            dispatch(api.PPTokenGenerator());
          // dispatch(api.publishToWeb());
          // dispatch(api.fetchPublication());
          //dispatch(api.fetchAllUnAssignedAreas());
          // dispatch(api.fetchAllAssignedAreas());
          dispatch(api.fetchAllAreas());
          dispatch(api.fetchLandlords(auth.info.profile.adminHomeOffice));
          dispatch(api.fetchAllBranches());
          dispatch(api.fetchAllRegions());
          dispatch(api.fetchUsers());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchCurrentAdminsBranchEnquiries());
          dispatch(api.fetchCurrentAdminsBranchListings());
          dispatch(api.fetchCancelReasons());
          dispatch(api.fetchPaymentMethods());
          dispatch(api.fetchPromos());
          dispatch(api.fetchCanvas());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchUserTypes());
          dispatch(api.fetchSettings());
          dispatch(api.fetchCommercialTypes());
          dispatch(api.fetchIndustrialTypes());
        } else if (role === "practiceadmin") {
          dispatch(api.fetchMedicalHistory());
          dispatch(api.fetchUsers());
          dispatch(api.fetchBrokers());
          dispatch(api.fetchBookings(auth.info.uid, role));
          dispatch(api.fetchCancelReasons());
          dispatch(api.fetchPaymentMethods());
          dispatch(api.fetchPromos());

          dispatch(api.fetchUserTypes());
          dispatch(api.fetchCommercialTypes());
          dispatch(api.fetchIndustrialTypes());
          dispatch(api.fetchSettings());
        } else {
          alert(language.not_valid_user_type);
          dispatch(signOut());
        }
      } else {
        alert(language.user_issue_contact_admin);
        dispatch(signOut());
      }
    }
  }, [
    auth.info,
    dispatch,
    fetchBookings,
    fetchCancelReasons,
    fetchBrokerEarnings,
    fetchEarningsReport,
    fetchNotifications,
    fetchPromos,
    fetchUsers,
    fetchWithdraws,
    signOut,
    fetchAllListings,
    // publishToWeb,
  ]);
  return auth.loading ? <CircularLoading /> : props.children;
}
export default AuthLoading;
